import React from "react";

import TopNav from "../components/TopNav";
import PrivateMessageSystem from "../components/PrivateMessageSystem";

//adminfdxva: mkJww]8@w2qBDXRumBtr
const apiEndpoint = "https://fdxva.org/api/messages";
const MessagePage = (props) => {
    return (
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <PrivateMessageSystem
                currentUserId={props.iid}
                apiEndpoint={apiEndpoint}
                darkMode={props.darkmode}
            />
        </React.Fragment>
    );
}

export default MessagePage;
